module.exports = __webpack_public_path__ + "img/bim1.79cba330.png";